import hgpMachine from './main.vue';

export default {
  install(Vue) {
    Vue.component(hgpMachine.name, hgpMachine);
  },
};
